/**
 * IMPEX Feature Showcase - Theme Editor & Interactive Script
 */
(function () {
  'use strict';

  function initFeatureShowcase(sectionEl) {
    if (!sectionEl || sectionEl.dataset.ifsInitialized) return;
    sectionEl.dataset.ifsInitialized = 'true';

    // Handle scroll reveal or image load enhancement
    var images = sectionEl.querySelectorAll('.ifs-row__image');
    images.forEach(function (img) {
      if (img.complete) {
        img.classList.add('is-loaded');
      } else {
        img.addEventListener('load', function () {
          img.classList.add('is-loaded');
        });
      }
    });
  }

  function handleBlockSelect(event) {
    var blockId = event.detail.blockId;
    var blockEl = document.querySelector('[data-block-id="' + blockId + '"]');
    if (blockEl) {
      blockEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      blockEl.classList.add('is-selected');
    }
  }

  function handleBlockDeselect(event) {
    var blockId = event.detail.blockId;
    var blockEl = document.querySelector('[data-block-id="' + blockId + '"]');
    if (blockEl) {
      blockEl.classList.remove('is-selected');
    }
  }

  function initAll() {
    var sections = document.querySelectorAll('.ifs-section');
    sections.forEach(initFeatureShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Theme Editor Events
  document.addEventListener('shopify:section:load', function (event) {
    var sectionEl = event.target.querySelector('.ifs-section') || event.target;
    if (sectionEl && sectionEl.classList && sectionEl.classList.contains('ifs-section')) {
      initFeatureShowcase(sectionEl);
    }
  });

  document.addEventListener('shopify:block:select', handleBlockSelect);
  document.addEventListener('shopify:block:deselect', handleBlockDeselect);
})();
